<!-- <ul id="sub-menu" class="sidebar-menu" *ngIf="menuDisplayStatus">
    @for (menu of menuCustom; track menu; let i = $index) {
    <li *ngIf="menu.showMenu">
      <div class="collection-collapse-block"  [class.open]="menu.expandMenu">
        <h3 class="collapse-block-title" [class.active]="menu.active"
          (click)="menu.expandMenu=!menu.expandMenu">{{menu.title}}</h3>
        <div class="collection-collapse-block-content" >
          <ul class="submenu">
            @for (subMenu of menu.subMenu; track subMenu; let j=$index) {
            <li [class.active]="subMenu.active" (click)="setActive(i,j);goTo(subMenu.link)"
              *ngIf="subMenu.show">
              <a class="has-submenu" href="javascript:void(0)">{{ subMenu.title }}</a>
            </li>
            }
          </ul>

        </div>
      </div>
    </li>
    }
    <li>
    </li>
    <li *ngIf="supportVisible">

        <h3 class="collapse-block-title active" (click)="goTo('/vendor/all-vendor-tickets')" style="cursor: pointer;font-weight: 500;color: #444;">Support</h3>
    
    </li>
  </ul> -->

<ul id="sub-menu" class="sidebar-menu" *ngIf="menuDisplayStatus">

  @for (menu of menuCustom; track menu; let i = $index) {
  <li *ngIf="menu.showMenu">
    <div class="collection-collapse-block" [class.open]="menu.expandMenu">

      <!-- Parent menu -->
      <h3 class="collapse-block-title" [class.active]="menu.active" (click)="openSidebarAndToggle(menu)">
        <!-- 
        <i [class]="menu.icon" class="primary-color" style="cursor: pointer; " (click)="$event.stopPropagation(); openSidebarAndToggle(menu)">
        </i> -->
        <span class="menu-icon primary-color" (click)="$event.stopPropagation(); openSidebarAndToggle(menu)">

          <!-- FontAwesome Icon -->
          <i *ngIf="menu.iconType === 'fa'" [class]="menu.icon" [title]="menu.title">
          </i>

          <!-- SVG Icon -->
          <img *ngIf="menu.iconType === 'svg'" [src]="menu.svgPath" class="svg-icon" [title]="menu.title" />

        </span>

        <span *ngIf="!collapsed">
          {{ menu.title }}
        </span>
      </h3>

      <!-- Submenu -->
      <div class="collection-collapse-block-content">
        <ul class="submenu">

          @for (subMenu of menu.subMenu; track subMenu; let j = $index) {
          <li *ngIf="subMenu.show" [class.active]="subMenu.active" (click)="setActive(i, j); goTo(subMenu.link)" data-bs-dismiss="offcanvas">

            <a class="has-submenu" style="display:flex; align-items:center; gap:10px;">

              <!-- Submenu FontAwesome Icon -->
              <!-- <i [class]="subMenu.icon" class="primary-color"></i> -->

              <span class="menu-icon primary-color" (click)="$event.stopPropagation(); openSidebarAndToggle(menu)">

                <!-- FontAwesome Icon -->
                <i *ngIf="subMenu.iconType === 'fa'" [class]="subMenu.icon" [title]="subMenu.title">
                </i>

                <!-- SVG Icon -->
                <img *ngIf="subMenu.iconType === 'svg'" [src]="subMenu.svgPath" class="svg-icon" [title]="subMenu.title"/>

              </span>

              <span *ngIf="!collapsed" style="cursor: pointer;">
                {{ subMenu.title }}
              </span>

            </a>

          </li>
          }

        </ul>
      </div>

    </div>
  </li>
  }

  <!-- Support -->


</ul>

<ul id="sub-menu" class="sidebar-menu" *ngIf="supportVisible || menuDisplayStatus">
  <h3 class="collapse-block-title active m-4 p-2" (click)="goTo('/vendor/all-vendor-tickets')">

    <!-- Support Icon -->
    <!-- <i *ngIf="subMenu.iconType === 'fa'" class="fa-solid fa-headset primary-color"></i> -->

    <img  src="assets/images/icon/Support-svg-icon-1.svg" class="svg-icon" title="Support" />


    <span *ngIf="!collapsed">
      Support
    </span>

  </h3>
</ul>


<!-- <ul id="sub-menu" class="sidebar-menu">
    <li *ngFor="let menu of menuCustom; let i = index" class="menu-item">
      
      <a class="parent-link" href="javascript:void(0)">
        {{ menu.title }}
        <span class="sub-arrow" *ngIf="menu.subMenu"></span>
      </a>
      
      <ul *ngIf="menu.subMenu" class="submenu">
        <li *ngFor="let subMenu of menu.subMenu; let j = index">
          
          <a class="has-submenu" [routerLink]="subMenu.link" *ngIf="subMenu.type === 'link'">
            {{ subMenu.title }}
          </a>
  
          <a class="has-submenu" href="{{ subMenu.link }}" *ngIf="subMenu.type === 'extLink'">
            {{ subMenu.title }}
          </a>
  
          <a class="has-submenu" href="{{ subMenu.link }}" target="_blank" *ngIf="subMenu.type === 'extTabLink'">
            {{ subMenu.title }}
          </a>
          
        </li>
      </ul>
    </li>
  </ul>
   -->



<!-- <ul id="sub-menu" class="sidebar-menu">
        <li >
            <a href="javascript:void(0)"  
                >
          test
               <span class="sub-arrow"  *ngIf="true"></span>
            </a>
            <a>
               test2
               <span class="sub-arrow" *ngIf="true"></span>
            </a>
            <a >
               Test3
               <span class="sub-arrow" *ngIf="true"></span>
            </a>
            <a href="#" >
              Test4
               <span class="sub-arrow" *ngIf="true"></span>
            </a>
            <ul [class]="'mega-menu clothing-menu'" [class.opensub1]="'active'" *ngIf="true">
              
              <ng-container *ngIf="!menuItem.megaMenu">
                <li *ngFor="let childrenItem of menuItem.children">

                  <a class="has-submenu" [routerLink]="childrenItem.path" *ngIf="childrenItem.type === 'link'">
                     {{childrenItem.title}}
                  </a>
                  
                  <a href="{{ !childrenItem.type ? null : childrenItem.path }}" *ngIf="childrenItem.type === 'extLink'">
                    {{childrenItem.title}}
                  </a>
                  
                  <a href="{{ !childrenItem.type ? null : childrenItem.path }}" target="_blank" *ngIf="childrenItem.type === 'extTabLink'">
                     {{childrenItem.title}}
                  </a>
                  
                  <ul *ngIf="childrenItem.children">
                    <li *ngFor="let childrenSubItem of childrenItem.children">
                        
                        <a [routerLink]="childrenSubItem.path" *ngIf="childrenSubItem.type === 'link'">
                           {{childrenSubItem.title}}
                        </a>
                        
                        <a href="{{ childrenSubItem.path }}" *ngIf="childrenSubItem.type === 'extLink'">
                          {{childrenSubItem.title}}
                        </a>
                        
                        <a href="{{ childrenSubItem.path }}" target="_blank" *ngIf="childrenSubItem.type === 'extTabLink'">
                           {{childrenSubItem.title}}
                        </a>
                        
                        <ul *ngIf="childrenSubItem.children">
                          <li *ngFor="let childrenSubSubItem of childrenSubItem.children">
                              
                              <a [routerLink]="childrenSubSubItem.path" *ngIf="childrenSubSubItem.type === 'link'">
                                 {{childrenSubSubItem.title}}
                              </a>
                              
                              <a href="{{ childrenSubSubItem.path }}" *ngIf="childrenSubSubItem.type === 'extLink'">
                                {{childrenSubSubItem.title}}
                              </a>
                              
                              <a href="{{ childrenSubSubItem.path }}" target="_blank" *ngIf="childrenSubSubItem.type === 'extTabLink'">
                                 {{childrenSubSubItem.title}}
                              </a>
                              
                              <ul *ngIf="childrenSubSubItem.children">
                                <li *ngFor="let childrenSubSubSubItem of childrenSubSubItem.children">
                                    
                                    <a [routerLink]="childrenSubSubSubItem.path" *ngIf="childrenSubSubSubItem.type === 'link'">
                                       {{childrenSubSubSubItem.title}}
                                    </a>
                                    
                                    <a href="{{ childrenSubSubSubItem.path }}" *ngIf="childrenSubSubSubItem.type === 'extLink'">
                                      {{childrenSubSubSubItem.title}}
                                    </a>
                                    
                                    <a href="{{ childrenSubSubSubItem.path }}" target="_blank" *ngIf="childrenSubSubSubItem.type === 'extTabLink'">
                                       {{childrenSubSubSubItem.title}}
                                    </a>
                                </li>
                              </ul>
                          </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ng-container>
              
            </ul>
          </li>
      </ul> -->